import DoorImage from './DoorImage';
import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag, Check } from "lucide-react";
import { toast } from "sonner";
import { useLang, localized } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { FILE_URL } from "../lib/api";

const DEFAULT_DOOR = "https://images.unsplash.com/photo-1659720879327-827462ca3942?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsJTIwaW50ZXJpb3IlMjBkb29yfGVufDB8fHx8MTc4NDE0NzE2Mnww&ixlib=rb-4.1.0&q=85";

export default function DoorCard({ door: d, showQuick = true }) {
  const { t, lang } = useLang();
  const { isFavorite, toggleFavorite, addToCart, inCart } = useAuth();
  const fav = isFavorite(d.id);
  const isInCart = inCart(d.id);

  const onFav = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleFavorite(d.id);
  };
  const onAddCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(d.id);
    toast.success(t("cart.added"));
  };

  return (
    <div className="group relative fd-hover-lift" data-testid={`door-card-${d.id}`}>
      <Link to={`/doors/${d.id}`} className="block">
        <div className="relative aspect-[3/4] overflow-hidden bg-neutral-100">
          <DoorImage src={d.image_id ? FILE_URL(d.image_id) : DEFAULT_DOOR} alt={localized(d.name, lang)} fallback={DEFAULT_DOOR} />
          {showQuick && (
            <button
              onClick={onFav}
              aria-label="favorite"
              className={`absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-white/90 backdrop-blur-sm border border-neutral-200 transition-colors ${fav ? "text-red-600" : "text-neutral-700 hover:text-red-600"}`}
              data-testid={`fav-btn-${d.id}`}
            >
              <Heart size={16} fill={fav ? "currentColor" : "none"} />
            </button>
          )}
        </div>
        <div className="mt-4 flex items-start justify-between gap-4">
          <div className="min-w-0">
            <p className="fd-label mb-1">{t(`categories.${d.category}`)}</p>
            <h3 className="text-lg text-neutral-900 truncate">{localized(d.name, lang)}</h3>
            {d.dimensions && <p className="text-xs text-neutral-500 mt-1">{d.dimensions}</p>}
          </div>
          <p className="text-neutral-900 text-sm whitespace-nowrap">{d.price} {t("common.currency")}</p>
        </div>
      </Link>
      {showQuick && (
        <button
          onClick={onAddCart}
          className={`mt-3 w-full justify-center text-xs inline-flex items-center gap-2 px-3 py-2 border transition-colors ${
            isInCart
              ? "border-neutral-900 bg-neutral-900 text-white"
              : "border-neutral-300 text-neutral-800 hover:border-neutral-900"
          }`}
          data-testid={`add-cart-btn-${d.id}`}
        >
          {isInCart ? <><Check size={14} /> {t("cart.in_cart")}</> : <><ShoppingBag size={14} /> {t("cart.add")}</>}
        </button>
      )}
    </div>
  );
}
